module.exports = __webpack_public_path__ + "static/media/rbf_logo.97a0321f.jpg";